/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

export interface FilePreviewProps {
    src?: string;
    fileMimeType?: string;
}

export const FilePreview = ({ src, fileMimeType }: FilePreviewProps) => {
    return (
        <div>
            {fileMimeType && (
                <>
                    {fileMimeType.startsWith('image') && <img src={src} alt="" width="100%" height="100%" />}
                    {fileMimeType.startsWith('video') && (
                        <video src={src} controls controlsList="nodownload" width="100%">
                            Your browser does not support the video tag.
                        </video>
                    )}
                    {fileMimeType.startsWith('audio') && (
                        <audio src={src} controls controlsList="nodownload">
                            Your browser does not support the audio tag.
                        </audio>
                    )}
                </>
            )}
        </div>
    );
};
